<template>
  <div>
    <vs-alert
      v-if="$validator.errors.all().length > 0"
      color="danger"
      title="Atenção!!"
      active="true"
      class="my-3"
      style="height: auto !important"
    >
      <ul>
        <li
          class="mb-2"
          v-for="error in $validator.errors.all()"
          :key="error.id"
        >
          {{ error }}
        </li>
      </ul>
    </vs-alert>

    <!-- Tabs -->
    <div class="con-vs-tabs vs-tabs vs-tabs-primary vs-tabs-position-top">
      <div class="con-ul-tabs">
        <ul class="ul-tabs vs-tabs--ul ul-tabs-left">
          <!-- Tab: Dados Gerais -->
          <li class="vs-tabs--li" :class="passo == 0 ? 'activeChild' : ''">
            <button @click="passo = 0" type="button" class="vs-tabs--btn">
              <span>Dados Gerais</span>
            </button>
          </li>

          <!-- Tab: Resumo -->
          <li
            v-if="passoAtual"
            class="vs-tabs--li"
            :class="passo == 1 ? 'activeChild' : ''"
          >
            <button @click="passo = 1" type="button" class="vs-tabs--btn">
              <span>Resumo</span>
            </button>
          </li>

          <!-- Tab: Dados da Cobranças -->
          <li
            v-if="passoAtual == 2"
            class="vs-tabs--li"
            :class="passo == 2 ? 'activeChild' : ''"
          >
            <button @click="passo = 2" type="button" class="vs-tabs--btn">
              <span>Dados da Cobranças</span>
            </button>
          </li>

          <!-- Tab: Registros Financeiros Gerados -->
          <li
            v-if="passoAtual == 4"
            class="vs-tabs--li"
            :class="passo == 4 ? 'activeChild' : ''"
          >
            <button @click="passo = 4" type="button" class="vs-tabs--btn">
              <span>Registros Financeiros Gerados</span>
            </button>
          </li>
        </ul>
      </div>
    </div>

    <!-- Dados Gerais -->
    <div :class="passo == 0 ? 'div-show' : 'div-hide'">
      <form role="form" @submit.stop.prevent="onSubmit">
        <div class="vx-row mt-4">
          <div class="vx-col sm:w-1/2 w-full mb-3">
            <vs-select
              v-if="contas"
              v-model="formCadastro.tipoRateio"
              id="Tipo de Rateio"
              label="Tipo de Rateio"
              class="select-large w-full"
              name="Tipo de Rateio"
              v-validate="{ required: true }"
              :state="validateState('Tipo de Rateio')"
              :class="validateClass('Tipo de Rateio')"
              @input="selecionaTipo()"
            >
              <vs-select-item :key="0" :value="null" :text="'Selecione'" />
              <vs-select-item
                :key="index + 1"
                :value="item.id"
                :text="`${item.label}`"
                v-for="(item, index) in tiposRateio"
              />
            </vs-select>
          </div>
          <div class="vx-col sm:w-1/2 w-full mb-3">
            <vs-select
              v-if="carteirasCobranca"
              v-model="formCadastro.idCarteiraCobranca"
              id="Carteira de Cobrança"
              label="Carteira de Cobrança"
              class="select-large w-full"
              name="Carteira de Cobrança"
              v-validate="{ required: true }"
              :state="validateState('Carteira de Cobrança')"
              :class="validateClass('Carteira de Cobrança')"
            >
              <vs-select-item :key="0" :value="null" :text="'Selecione'" />
              <vs-select-item
                :key="index + 1"
                :value="item.id"
                :text="`${item.label}`"
                v-for="(item, index) in carteirasCobranca"
              />
            </vs-select>
          </div>
        </div>
        <div class="vx-row mb-4">
          <div class="vx-col sm:w-1/3 w-full mb-3">
            <label for class="vs-input--label">Mês Referencia Eventos</label>
            <datepicker
              :minimumView="'month'"
              :maximumView="'year'"
              label-placeholder="Mês Referencia Eventos"
              name="Mês Referencia Eventos"
              id="Mês Referencia Eventos"
              input-class="inputData w-full large"
              :format="'MM/yyyy'"
              label="MM/YYYY"
              :language="languages['ptBR']"
              v-model="formCadastro.mesRefenciaEventos"
              :state="validateState('Mês Referencia Eventos')"
              :class="validateClass('Mês Referencia Eventos')"
              @input="preencheDatasReferencias"
            ></datepicker>

            <!--vs-input
              size="large"
              class="w-full"
              label-placeholder="Mês Referencia Eventos"
              name="Mês Referencia Eventos"
              id="Mês Referencia Eventos"
              v-mask="'##/####'"
              v-model="formCadastro.mesRefenciaEventos"
              v-validate="{ required: true, min: 7 }"
              :state="validateState('Mês Referencia Eventos')"
              :class="validateClass('Mês Referencia Eventos')"
              val-icon-danger="clear"
              danger-text="Preencha este Campo"
            /-->
          </div>
          <div class="vx-col sm:w-1/3 w-full mb-3">
            <label for class="vs-input--label">Mês Referencia Cobranças</label>
            <datepicker
              :minimumView="'month'"
              :maximumView="'year'"
              label-placeholder="Mês Referencia Boletos"
              name="Mês Referencia Boletos"
              id="Mês Referencia Boletos"
              input-class="inputData w-full large"
              :format="'MM/yyyy'"
              label="MM/YYYY"
              :language="languages['ptBR']"
              v-model="formCadastro.mesReferenciaBoleto"
              :state="validateState('Mês Referencia Boletos')"
              :class="validateClass('Mês Referencia Boletos')"
              :disabled="habilitarDatasReferencias"
            ></datepicker>

            <!--vs-input
              size="large"
              class="w-full"
              label-placeholder="Mês Referencia Boletos"
              name="Mês Referencia Boletos"
              id="Mês Referencia Boletos"
              v-mask="'##/####'"
              v-model="formCadastro.mesReferenciaBoleto"
              v-validate="{ required: true, min: 7 }"
              :state="validateState('Mês Referencia Boletos')"
              :class="validateClass('Mês Referencia Boletos')"
              val-icon-danger="clear"
              danger-text="Preencha este Campo"
            /-->
          </div>
          <div class="vx-col sm:w-1/3 w-full mb-3">
            <label for class="vs-input--label">Mês Vencimento Cobranças</label>
            <datepicker
              :minimumView="'month'"
              :maximumView="'year'"
              label-placeholder="Mês Vencimento Boletos"
              name="Mês Vencimento Boletos"
              id="Mês Vencimento Boletos"
              input-class="inputData w-full large"
              :format="'MM/yyyy'"
              label="MM/YYYY"
              :language="languages['ptBR']"
              v-model="formCadastro.mesVencimentoBoleto"
              :state="validateState('Mês Vencimento Boletos')"
              :class="validateClass('Mês Vencimento Boletos')"
              :disabled="habilitarDatasReferencias"
            ></datepicker>

            <!--vs-input
              size="large"
              class="w-full"
              label-placeholder="Mês Referencia Boletos"
              name="Mês Referencia Boletos"
              id="Mês Referencia Boletos"
              v-mask="'##/####'"
              v-model="formCadastro.mesReferenciaBoleto"
              v-validate="{ required: true, min: 7 }"
              :state="validateState('Mês Referencia Boletos')"
              :class="validateClass('Mês Referencia Boletos')"
              val-icon-danger="clear"
              danger-text="Preencha este Campo"
            /-->
          </div>
        </div>
        <div class="vx-row mb-4">
          <div class="vx-col sm:w-1/3 w-full mb-3">
            <vs-select
              v-if="situacoes.length > 0"
              v-model="formCadastro.statusParticipantes"
              label="Status Participantes"
              class="select-large w-full"
              name="Status"
              multiple
              :state="validateState('Status')"
              :class="validateClass('Status')"
              @input="selecionaTipo(), selecionaStatus()"
              v-validate="{ required: true }"
            >
              <vs-select-item
                :key="index"
                :value="item.id"
                :text="item.label"
                v-for="(item, index) in situacoes"
              />
            </vs-select>
          </div>
          <div class="vx-col sm:w-1/3 w-full mb-3">
            <vs-select
              v-if="diasVencimento.length > 0"
              v-model="formCadastro.diasVencimento"
              id="Dias de Vencimento"
              label="Dias de Vencimento"
              class="select-large w-full"
              name="Dias de Vencimento"
              multiple
              v-validate="{ required: true }"
              :state="validateState('Dias de Vencimento')"
              :class="validateClass('Dias de Vencimento')"
              @input="selecionaTipo(), selecionaDatas()"
            >
              <vs-select-item
                :key="index"
                :value="item.id"
                :text="`${item.label}`"
                v-for="(item, index) in diasVencimento"
              />
            </vs-select>
          </div>
          <div class="vx-col sm:w-1/3 w-full mb-3">
            <label for class="vs-input--label">Cadastrados Até</label>
            <datepicker
              input-class="inputData w-full large"
              :format="'dd/MM/yyyy'"
              label="DD/MM/YYYY"
              v-model="formCadastro.cadastrosAte"
              v-validate="{
                required: true,
                min: 10,
                date_format: 'dd/MM/yyyy',
              }"
              :monday-first="true"
              :auto-placement="true"
              :language="languages['ptBR']"
              calendar-class="classeDoCalendario"
              name="Cadastrados Até"
              :state="validateState('Cadastrados Até')"
              :danger="validateClass('Cadastrados Até')"
              @input="selecionaTipo()"
            ></datepicker>
            <!--vs-input
              size="large"
              class="w-full"
              label-placeholder="Cadastros Até'"
              name="Cadastros Até"
              id="Cadastros Até"
              v-mask="'##/##/####'"
              v-model="formCadastro.cadastrosAte"
              v-validate="{
                required: true,
                min: 10,
                date_format: 'dd/MM/yyyy',
              }"
              :state="validateState('Cadastros Até')"
              :class="validateClass('Cadastros Até')"
              val-icon-danger="clear"
              danger-text="Preencha este Campo"
              @blur="selecionaTipo()"
            /-->
          </div>
        </div>
        <div v-if="formCadastro.tipoRateio == 'Direto'">
          <div class="vx-row mb-4">
            <div class="vx-col sm:w-1/3 w-full mb-3">
              <label for="" class="vs-select--label"
                >Valor Total de Eventos</label
              >
              <money
                class="w-full vs-inputx vs-input--input large"
                name="Valor Total de Eventos"
                id="Valor Total de Eventos"
                v-model="formCadastro.valorTotalEventos"
                v-validate="{ required: true }"
                :state="validateState('Valor Total de Eventos')"
                :danger="validateClass('Valor Total de Eventos')"
                v-bind="money"
              ></money>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input
                size="large"
                class="w-full"
                label-placeholder="Total de Cotas'"
                name="Total de Cotas"
                id="Total de Cotas"
                v-model="formCadastro.totalCotas"
                v-validate="{
                  required: true,
                }"
                :state="validateState('Total de Cotas')"
                :class="validateClass('Total de Cotas')"
                val-icon-danger="clear"
                danger-text="Preencha este Campo"
              />
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <label for="" class="vs-select--label">
                Total de Veículos Participantes</label
              ><br /><br />
              <a href="javascript:void()" @click="abreVeiculosParticipantes()"
                >{{ totalVeiculos }} Veículo(s)
              </a>
            </div>
          </div>
          <div class="vx-row mb-4" v-if="modalVeiculosParticipantes == true">
            <div class="vx-col sm:w-1/1 w-full mb-3">
              <table class="table-bordered mt-3">
                <tr>
                  <th>Beneficiário</th>
                  <th>Placa</th>
                  <th>Chassi</th>
                  <th>Cota</th>
                  <th>Dia Vencimento</th>
                  <th>Status</th>
                </tr>
                <tr v-for="item in veiculosParticipantes" :key="item.id">
                  <td>
                    {{ item.nome }}
                    <router-link
                      target="_blank"
                      :to="`/DetalheAssociado/${item.id_associado}`"
                    >
                      <feather-icon
                        icon="ExternalLinkIcon"
                        svgClasses="h-4 w-4"
                      />
                    </router-link>
                  </td>
                  <td>
                    {{ item.placa }}
                  </td>
                  <td>
                    {{ item.chassi }}
                  </td>
                  <td>
                    {{ item.cotaTabela }}
                  </td>
                  <td>
                    {{ item.diaVencimento }}
                  </td>
                  <td>
                    {{ item.situacaoVeiculo }}
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </div>
        <div v-if="formCadastro.tipoRateio == 'Simples'">
          <div class="vx-row mb-4">
            <div class="vx-col sm:w-1/2 w-full mb-3">
              <label for="" class="vs-select--label"
                >Valor Total Rateio para todas as Cotas</label
              >
              <money
                class="w-full vs-inputx vs-input--input large"
                name="Valor Total Rateio para todas as Cotas"
                id="Valor Total Rateio para todas as Cotas"
                v-model="formCadastro.valorGeralRateio"
                v-validate="{ required: true }"
                :state="validateState('Valor Total Rateio para todas as Cotas')"
                :danger="
                  validateClass('Valor Total Rateio para todas as Cotas')
                "
                v-bind="money"
              ></money>
            </div>
          </div>
        </div>
        <div v-if="formCadastro.tipoRateio == 'Detalhado'">
          <hr class="mb-3" />
          <div
            v-for="item in regionais"
            :key="item.idRegional"
            class="vx-row mb-4"
          >
            <div class="vx-col sm:w-1/1 w-full mb-3">
              <vx-card :title="item.nomeRegional">
                <table class="table-bordered">
                  <tr>
                    <th v-for="itemFipe in tiposFipe" :key="itemFipe.id">
                      {{ itemFipe.label }}
                    </th>
                  </tr>
                  <tr>
                    <td
                      v-for="itemFipe2 in item.tipoFipe"
                      :key="itemFipe2.idTipoFipe"
                    >
                      <label for="" class="vs-select--label"
                        >Valor Total Rateio
                      </label>
                      <money
                        class="w-full vs-inputx vs-input--input large"
                        :name="`Valor Total Rateio (${item.nomeRegional}/${itemFipe2.nomeFipe})`"
                        :id="`Valor Total Rateio (${item.nomeRegional}/${itemFipe2.nomeFipe})`"
                        v-model="itemFipe2[item.idReginal]"
                        v-validate="{ required: true }"
                        :state="
                          validateState(
                            `Valor Total Rateio (${item.nomeRegional}/${itemFipe2.nomeFipe})`,
                          )
                        "
                        :danger="
                          validateClass(
                            `Valor Total Rateio (${item.nomeRegional}/${itemFipe2.nomeFipe})`,
                          )
                        "
                        v-bind="money"
                      ></money>
                    </td>
                  </tr>
                </table>
              </vx-card>
            </div>
          </div>
        </div>
        <div v-if="!dados.dataFinalizacao" class="vx-row">
          <div class="vx-col w-full text-right mt-5">
            <vs-button
              color="warning"
              type="border"
              class="mr-3 mb-2"
              @click.stop.prevent="onReset"
              >Cancelar</vs-button
            >

            <BotaoSubmit
              variant="success"
              :edit="this.dados.idRateio == null ? false : true"
              :aguarde="aguardeCadastro"
            ></BotaoSubmit>
          </div>
        </div>
      </form>
    </div>

    <!-- Resumo -->
    <div :class="passo == 1 ? 'div-show' : 'div-hide'" id="container-modal">
      <h4 class="mt-5">Erros</h4>
      <vs-alert
        v-if="criticas.length > 0"
        color="danger"
        title="Atenção!!"
        active="true"
        class="my-3"
        style="height: auto !important"
      >
        Alguns erros foram encontrados que podem impactar o rateio.
      </vs-alert>
      <vs-alert
        v-else
        color="primary"
        title="Atenção!!"
        active="true"
        class="my-3"
        style="height: auto !important"
      >
        Nenhum Erro foi encontrado, você já pode gerar o Rateio
      </vs-alert>

      <table v-if="criticas.length > 0" class="table-bordered">
        <tr>
          <th>Critica</th>
          <th>Quantidade</th>
          <th></th>
        </tr>
        <tr v-for="item in criticas" :key="item.id">
          <td>
            {{ convertTranslate(item.tipo) }}
          </td>
          <td>
            {{ item.qtd }}
          </td>
          <td>
            <a
              href="javascript:void(0)"
              @click="exibeResultadoCritica(item)"
              class="vs-button d-inline vs-button-dark vs-button-gradient includeIcon includeIconOnly vs-radius"
            >
              <feather-icon icon="SearchIcon" svgClasses="h-4 w-4" />
            </a>
          </td>
        </tr>
      </table>
      <div v-if="resultadoCritica.length > 0">
        <h5 class="my-3">Resultado Critica - {{ titleCritica }}</h5>
        <table v-if="idCriticaResult == 5" class="table-bordered">
          <tr>
            <th>Beneficiário</th>
            <th>Chassi</th>
            <th>Placa</th>
            <th>Valor Cobertura</th>
            <th>Cota Atual</th>
            <th>Cota Correta</th>
          </tr>
          <tr v-for="item in resultadoCritica" :key="item.id">
            <td>
              {{ item.id_associado }}
              <router-link
                target="_blank"
                :to="`/DetalheAssociado/${item.id_associado}`"
              >
                <feather-icon icon="ExternalLinkIcon" svgClasses="h-4 w-4" />
              </router-link>
            </td>
            <td>
              {{ item.chassi }}
            </td>
            <td>
              {{ item.placa }}
            </td>
            <td>
              {{ item.valorCobertura | currency }}
            </td>
            <td>
              {{ item.cotaAtual }}
            </td>
            <td>
              {{ item.cotaQueDeveriaSer }}
            </td>
          </tr>
        </table>
        <table v-else class="table-bordered">
          <tr>
            <th>Beneficiário</th>
            <th>Chassi</th>
            <th>Placa</th>
          </tr>
          <tr v-for="item in resultadoCritica" :key="item.id">
            <td>
              {{ item.id_associado }}
              <router-link
                target="_blank"
                :to="`/DetalheAssociado/${item.id_associado}`"
              >
                <feather-icon icon="ExternalLinkIcon" svgClasses="h-4 w-4" />
              </router-link>
            </td>
            <td>
              {{ item.chassi }}
            </td>
            <td>
              {{ item.placa }}
            </td>
          </tr>
        </table>
      </div>
      <div v-if="!dados.dataFinalizacao" class="vx-row mb-4">
        <div class="vx-col sm:w-1/1 w-full mb-3 text-right">
          <vs-button
            v-if="criticas.length > 0"
            color="warning"
            type="border"
            class="mr-3 mt-3"
            @click="onSubmit"
            >Atualizar Critica de Erros</vs-button
          >
          <vs-button
            v-if="criticas.length > 0"
            color="success"
            class="mt-3"
            @click="conferenciaDeValores"
            >Conferencia de Valores Independente de Erros</vs-button
          >
          <vs-button
            v-else
            color="success"
            class="mt-3"
            @click="conferenciaDeValores"
            >Conferencia de Valores</vs-button
          >
        </div>
      </div>
    </div>

    <!-- Dados da Cobrança -->
    <div :class="passo == 2 ? 'div-show' : 'div-hide'">
      <AlertNoneRateios class="my-3" v-if="boletosRateio.length == 0" />
      <AlertConsolidado class="my-3" v-else :data-consolidado="consolidado" />

      <vs-card>
        <div :class="`vx-row mb-0`">
          <div class="vx-col sm:w-1/4 w-full mt-3">
            <span>Nome Beneficiário</span>
            <AutoComplete
              customClass="w-full"
              name="Nome"
              id="Nome"
              v-model="formFiltro.nomeAssociado"
              :configAutoComplete="{ model: 'Associados', field: 'nome' }"
            />
          </div>

          <!-- CPF/CNPJ -->
          <div class="vx-col sm:w-1/4 w-full mt-3">
            <span>CPF/CNPJ</span>
            <AutoComplete
              customClass="w-full"
              name="Cpf Cnpj"
              id="Cpf Cnpj"
              v-model="formFiltro.cpfCnpj"
              :configAutoComplete="{ model: 'Associados', field: 'cpfcnpj' }"
              :minimumCharacters="3"
            />
          </div>

          <!-- Placa -->
          <div :class="`vx-col sm:w-1/4 mt-3 w-full`">
            <span>Placa</span>
            <AutoComplete
              customClass="w-full"
              name="Placa"
              id="Placa"
              v-model="formFiltro.placa"
              :configAutoComplete="{ model: 'Veiculos', field: 'placa' }"
              :minimumCharacters="3"
            />
          </div>
          <div :class="`vx-col sm:w-1/4 mt-3 w-full`">
            <vs-button
              color="success"
              type="filled"
              icon-pack="feather"
              icon="icon-search"
              class="mt-4 w-full"
              @click="buscar(1)"
              >Buscar</vs-button
            >
          </div>
        </div>
      </vs-card>

      <vs-pagination
        v-if="qtdPaginas > 1"
        :total="qtdPaginas"
        v-model="paginaAtual"
      ></vs-pagination>

      Mostrando
      <span class="mr-2"
        >{{ boletosRateio.length }} de {{ paginaAtual * 30 - (30 - 1) }} -
        {{ qtdTotal }}</span
      >

      <div v-for="item in boletosRateio" :key="item.id" class="vx-row mb-4">
        <div class="vx-col sm:w-1/1 w-full mb-3">
          <vx-card :title="`${item.associado} - (${item.regional})`">
            <div v-for="veiculo in item.veiculos" :key="veiculo.id_veiculo">
              <h5>
                Veículo {{ veiculo.placa }} - Vencimento
                {{ item.diaVencimento }} - {{ item.nomePagamento }}
              </h5>
              <table class="table-bordered">
                <tr>
                  <th>Rateio</th>
                  <td>
                    {{ veiculo.valor | currency }} (cota
                    {{ veiculo.cotaTabela }})
                  </td>
                </tr>

                <tr
                  v-for="itemProduto in item.produtos.veiculos.flat()"
                  :key="'Produto_' + itemProduto.id"
                  v-if="itemProduto.idVeiculo === veiculo.id_veiculo"
                >
                  <th>
                    {{ itemProduto.nomeProduto }}
                  </th>
                  <td width="20%">
                    {{ itemProduto.valor | currency }}
                  </td>
                </tr>
              </table>
              <div class="text-right" v-if="veiculo.valorComissao">
                <b
                  >Total Sem Comissionamento:
                  {{
                    (veiculo.valorTotal - veiculo.valorComissao) | currency
                  }}</b
                >
              </div>
              <div class="text-right" v-if="veiculo.valorComissao">
                <b>Total da Comissão: {{ veiculo.valorComissao | currency }}</b>
              </div>
              <div class="text-right">
                <b>Total: {{ veiculo.valorTotal | currency }}</b>
              </div>
            </div>

            <div
              v-for="agregrado in item.agregados"
              :key="agregrado.idComplemento"
            >
              <h5>
                {{ $t('Agregado') }} {{ agregrado.placa }} - Vencimento
                {{ item.diaVencimento }} - {{ item.nomePagamento }}
              </h5>
              <table class="table-bordered">
                <tr>
                  <th>Rateio</th>
                  <td>
                    {{ agregrado.valor | currency }} (cota
                    {{ agregrado.cotaTabela }})
                  </td>
                </tr>
                <tr
                  v-for="itemProduto in item.produtos.agregados.flat()"
                  :key="'Agregado_' + itemProduto.idProduto"
                  v-if="itemProduto.idComplemento === agregrado.idComplemento"
                >
                  <th>
                    {{ itemProduto.nomeProduto }}
                  </th>
                  <td width="20%">
                    {{ itemProduto.valor | currency }}
                  </td>
                </tr>
              </table>

              <div class="text-right">
                <b>Total: {{ agregrado.valorTotal | currency }}</b>
              </div>
            </div>

            <h6 v-if="item.veiculos.length > 1">
              Valor Total Cobrança {{ item.valorTotal | currency }}
            </h6>
          </vx-card>
        </div>
      </div>
      <div v-if="!dados.dataFinalizacao" class="vx-row mb-4">
        <div class="vx-col sm:w-1/1 w-full mb-3 text-right">
          <vs-button
            color="warning"
            type="border"
            class="mr-3 mt-3"
            @click="conferenciaDeValores"
            >Atualizar Conferencia</vs-button
          >
          <vs-button
            v-if="boletosRateio.length > 0"
            color="success"
            class="mt-3"
            @click="gerarLancamentosFinanceiros"
            >Confirmar, gerar Lançamentos Financeiros</vs-button
          >
        </div>
      </div>
    </div>

    <!-- Registros Financeiros Gerados -->
    <div :class="passo == 4 ? 'div-show' : 'div-hide'">
      <AlertConsolidado :data-consolidado="consolidado" />

      <div class="vx-row mb-4 mt-3">
        <div class="vx-col sm:w-1/1 w-full mb-3">
          <table class="table-bordered mt-3">
            <tr>
              <th>Beneficiário</th>
              <th>Placa</th>
              <th>{{ $t('Regional') }}</th>
              <th>Forma de Pagamento</th>
              <th>Vencimento</th>
              <th>Valor</th>
            </tr>
            <tr v-for="item in boletosGerados" :key="item.id">
              <td>
                {{ item.nome }}
                <router-link
                  target="_blank"
                  :to="`/DetalheAssociado/${item.id_associado}`"
                >
                  <feather-icon icon="ExternalLinkIcon" svgClasses="h-4 w-4" />
                </router-link>
              </td>
              <td>
                {{ item.placa }}
              </td>
              <td>
                {{ item.regional }}
              </td>
              <td>
                {{ item.formaPagamento }}
              </td>
              <td>
                {{ item.vencimento }}
              </td>
              <td>
                {{ item.valor_titulo | currency }}
              </td>
            </tr>
          </table>
        </div>
      </div>

      <div v-if="!dados.dataFinalizacao" class="vx-row mb-4">
        <div class="vx-col sm:w-1/1 w-full mb-3 text-right">
          <vs-button
            color="warning"
            type="border"
            class="mr-3 mt-3"
            @click="conferenciaDeValores"
            >Atualizar Conferencia</vs-button
          >
          <vs-button
            color="success"
            class="mt-3"
            @click="gerarLancamentosFinanceiros"
            >Confirmar, gerar Lançamentos Financeiros</vs-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import locale from './../../../../locale';
import moment from 'moment';
import Datepicker from 'vuejs-datepicker';
import * as lang from 'vuejs-datepicker/src/locale';
import service from '../../../../services';
import BotaoSubmit from './../../../../components/BotaoSubmit';
import jwt from 'jsonwebtoken';
import { Money } from 'v-money';
import functions from '../../../../utils/functions';
import notify from '../../../../utils/notify';
// Components
import AlertNoneRateios from './components/alert-none-rateios.vue';
import AlertConsolidado from './components/alert-consolidado.vue';
import AutoComplete from './../../../../components/autocomplete/AutoComplete.vue';
import { decryptData } from '../../../../services/decryptData';
import { labelsTranslate } from '@/services/translate/translateMapper';
import { getTranslate } from '@/services/translate/translate';

export default {
  props: ['dados'],
  watch: {
    passo: function (newValue, oldValue) {
      if (newValue != oldValue) {
        this.$validator.validateAll();
      }
      if (newValue == 4) {
        this.buscaBoletosGerados();
      }
    },
    dados() {
      this.$validator.reset();
      this.preencheForm();
    },
    paginaAtual: function () {
      this.buscar(this.paginaAtual);
    },
  },
  data() {
    return {
      paginaAtual: 1,
      qtdTotal: 0,
      qtdPaginas: 0,
      habilitarDatasReferencias: true,
      ativaMascarasVeiculos: false,
      language: 'br',
      languages: lang,
      money: {
        decimal: '.',
        thousands: '',
        prefix: '',
        suffix: '',
        precision: 2,
      },
      formFiltro: {
        idEmpresa: null,
        cpfCnpj: null,
        nomeAssociado: null,
        placa: null,
      },
      modalCritica: false,
      titleCritica: '',
      idCriticaResult: null,
      passo: 0,
      passoAtual: null,
      contas: [],
      aguardeCadastro: false,
      dadosEmpresa: null,
      tiposRateio: [
        { label: 'Direto', id: 'Direto' },
        { label: 'Simples', id: 'Simples' },
        { label: 'Detalhado', id: 'Detalhado' },
      ],
      criticas: [],
      tiposFipe: [],
      regionais: [],
      boletosRateio: [],
      carteirasCobranca: [],
      boletosGerados: [],
      diasVencimento: [],
      situacoes: [],
      veiculosParticipantes: [],
      resultadoCritica: [],
      modalVeiculosParticipantes: false,
      dadosBanco: {
        camposObrigatoriosRemessa: '',
      },
      totalVeiculos: 0,
      formCadastro: {
        idCarteiraCobranca: null,
        tipoRateio: null,
        mesRefenciaEventos: null,
        mesReferenciaBoleto: null,
        mesVencimentoBoleto: null,
        statusParticipantes: [],
        valorTotalEventos: null,
        valorGeralRateio: null,
        valorForcadoTodos: null,
        diasVencimento: [],
        totalCotas: null,
      },
      idEmpresa: null,
      consolidado: null,
    };
  },
  methods: {
    async translateProposal() {
      if (!this.idEmpresa) return;
      const nameDefaultLocale = `default${this.idEmpresa}`;
      const translateDefault = await getTranslate(this.idEmpresa);
      if (translateDefault) {
        this.$i18n.setLocaleMessage(nameDefaultLocale, translateDefault);
        this.$i18n.locale = nameDefaultLocale;
      }
    },
    selecionaDatas() {
      //valida se foi selecionado o 0
      var aux = this.formCadastro.diasVencimento.filter((x) => x == 0);
      if (aux.length > 0) {
        this.formCadastro.diasVencimento = [];
        for (let index = 1; index < this.diasVencimento.length; index++) {
          const element = this.diasVencimento[index];
          this.formCadastro.diasVencimento.push(element.id);
        }
      }
    },
    selecionaStatus() {
      //valida se foi selecionado o 0
      var aux = this.formCadastro.statusParticipantes.filter((x) => x == 0);
      if (aux.length > 0) {
        this.formCadastro.statusParticipantes = [];
        for (let index = 1; index < this.situacoes.length; index++) {
          const element = this.situacoes[index];
          this.formCadastro.statusParticipantes.push(element.id);
        }
      }
    },
    closeModais() {
      this.modalCritica = false;
      this.modalVeiculosParticipantes = false;
    },
    formataMesAno(mesAno) {
      let dataAmericana = new Date('01/' + mesAno);
      //var mes = ;
      return new Date(moment(dataAmericana).format('DD/MM/YYYY'));
    },
    preencheForm() {
      this.passo = 0;

      if (this.dados.idRateio) {
        this.formCadastro.idRateio = this.dados.idRateio;
        this.formCadastro.idCarteiraCobranca = this.dados.idCarteiraCobranca;
        this.formCadastro.tipoRateio = this.dados.tipoRateio;
        this.formCadastro.status = this.dados.deletedAt == null ? true : false;
        this.formCadastro.mesRefenciaEventos = this.formataMesAno(
          this.dados.mesRefenciaEventos,
        );
        this.formCadastro.mesReferenciaBoleto = this.formataMesAno(
          this.dados.mesReferenciaBoleto,
        );
        this.formCadastro.mesVencimentoBoleto = this.formataMesAno(
          this.dados.mesVencimentoBoleto,
        );
        this.formCadastro.totalCotas = this.dados.totalCotas;
        this.formCadastro.valorGeralRateio = this.dados.valorGeralRateio;
        this.formCadastro.valorTotalEventos = this.dados.valorTotalEventos;
        this.formCadastro.valorForcadoTodos = this.dados.valorForcadoTodos;
        this.formCadastro.cadastrosAte = new Date(
          this.dados.cadastrosAte.replace('Z', ''),
        );
        this.formCadastro.diasVencimento = this.dados.vencimentos.split(',');
        this.formCadastro.statusParticipantes =
          this.dados.statusVeiculosParticipantes.split(',');
        this.passoAtual = this.dados.passo;
        if (this.dados.critica) {
          this.criticas = JSON.parse(this.dados.critica);
        }
        this.selecionaTipo();
        this.habilitarDatasReferencias = this.dados.passo == 1 ? false : true;
        this.naoExibirCriticas();
        this.consolidado = this.dados.consolidado
          ? JSON.parse(this.dados.consolidado)
          : null;
      } else {
        this.resetForm();
      }
    },
    resetForm() {
      this.passo = 0;
      this.passoAtual = 0;
      this.formCadastro.idRateio = null;
      this.formCadastro.idCarteiraCobranca = null;
      this.formCadastro.tipoRateio = null;
      this.formCadastro.mesRefenciaEventos = null;
      this.formCadastro.mesReferenciaBoleto = null;
      this.formCadastro.mesVencimentoBoleto = null;
      this.formCadastro.valorTotalEventos = null;
      this.formCadastro.valorGeralRateio = 0;
      this.formCadastro.valorForcadoTodos = null;
      this.formCadastro.diasVencimento = [];
      this.formCadastro.statusParticipantes = [];
      this.formCadastro.totalCotas = null;
      this.formCadastro.cadastrosAte = null;
    },
    verificaExibicao(tipo) {
      return this.dadosBanco.camposObrigatoriosRemessa.indexOf(tipo) >= 0;
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    validateClass(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return this.veeErrors.has(ref) ? 'has-error' : '';
      }
      return null;
    },
    validateStyle(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return {
          border: '1px solid red !important',
          borderRadius: '5px',
        };
      }
      return null;
    },
    convertTranslate(description) {
      const dataTranslate = labelsTranslate();
      const arrayWork = description.split(' ');
      let translate = '';
      arrayWork.forEach((element) => {
        translate += dataTranslate.some((work) => work[element])
          ? `${this.$t(`${element}`, { msg: element })} `
          : `${element} `;
      });

      return translate;
    },
    buscaDadosSelects(model, array, campoDescricao, campoPK) {
      service.getAll('g', {}, `${model}/list/`).then((res) => {
        res.data = decryptData(res.data);
        res.data.forEach((element) => {
          this[array].push({
            id: element[campoPK],
            label: element[campoDescricao],
          });
        });
        if (model == 'domTipoFipe') this.buscaDadosRegionais();
      });
    },
    buscaDadosSelectsPorEmpresa(model, array, campoDescricao, campoPK) {
      service
        .getAll('g', {}, `${model}/list/idEmpresa/idEmpresa=${this.idEmpresa}`)
        .then((res) => {
          res.data = decryptData(res.data);
          res.data.forEach((element) => {
            element.id = element[campoPK];
            element.label = element[campoDescricao];
            this[array].push(element);
          });
        });
    },
    buscaDadosAtivosSelectsPorEmpresa(model, array, campoDescricao, campoPK) {
      service
        .post(model, `list`, {
          idEmpresa: this.idEmpresa,
          notDeleted: true,
          tipoStatus: 'VEÍCULOS',
        })
        .then((res) => {
          this[array].push({ label: 'Selecionar Todos', id: 0 });
          res.data.forEach((element) => {
            element.id = element[campoPK];
            element.label = element[campoDescricao];
            this[array].push(element);
          });
        });
    },
    selecionaTipo() {
      if (this.formCadastro.tipoRateio == 'Direto') {
        this.buscarCotas();
        if (this.modalVeiculosParticipantes == true)
          this.abreVeiculosParticipantes();
      }
    },
    buscaBoletosGerados() {
      if (this.formCadastro.idRateio) {
        this.$vs.loading();
        service
          .post('Rateios', 'buscaBoletosGerados', this.formCadastro)
          .then((res) => {
            this.aguardeCadastro = false;
            this.$vs.loading.close();
            this.boletosGerados = [];
            res.data.forEach((element) => {
              this.boletosGerados.push(element);
            });
          })
          .catch(() => {
            this.aguardeCadastro = false;
            this.$vs.loading.close();
            this.$vs.notify({
              position: 'top-center',
              title: 'Atenção',
              text: 'Não foi possível buscar Dados',
              color: 'danger',
            });
          });
      }
    },
    buscaDadosRegionais() {
      var arrFipe = [];
      this.tiposFipe.forEach((element) => {
        arrFipe.push({
          idTipoFipe: element.id,
          nomeFipe: element.label,
        });
      });
      service
        .getAll('Regional', {}, 'list/idEmpresa=' + this.formCadastro.idEmpresa)
        .then((res) => {
          res.data.forEach((element) => {
            if (element.deletedAt == null) {
              arrFipe.forEach((elementa) => {
                elementa[element.idRegional] = 0;
              });
              this.regionais.push({
                idReginal: element.idRegional,
                nomeRegional: element.nome,
                tipoFipe: arrFipe,
              });
            }
          });
        });
    },
    exibeResultadoCritica(item) {
      this.titleCritica = item.tipo;
      this.idCriticaResult = item.idCritica;
      this.formCadastro.idEmpresa = this.dadosEmpresa[0].idEmpresa;

      if (this.formCadastro.idEmpresa) {
        this.$vs.loading();
        var objSend = {};
        objSend.idCritica = item.idCritica;
        objSend.idEmpresa = this.formCadastro.idEmpresa;
        service
          .post('Rateios', 'getResultadoCritica', objSend)
          .then((res) => {
            this.$vs.loading.close();
            this.resultadoCritica = [];
            res.data.forEach((element) => {
              this.resultadoCritica.push(element);
            });
          })
          .catch(() => {
            this.aguardeCadastro = false;
            this.$vs.loading.close();
            this.$vs.notify({
              position: 'top-center',
              title: 'Atenção',
              text: 'Não foi possível buscar Dados',
              color: 'danger',
            });
          });
      }
    },
    conferenciaDeValores() {
      if (this.formCadastro.idEmpresa) {
        let [data, hora] = moment(this.formCadastro.cadastrosAte)
          .format('yyyy-MM-DD HH:mm:ss')
          .split(' ');

        // cadastrados até o fim do dia da data selecionada
        hora = '23:59:59';
        const _cadastrosAte = `${data} ${hora}`;
        this.formCadastro.cadastrosAte = _cadastrosAte;
        this.$vs.loading();
        service
          .post('Rateios', 'conferenciaDeValores', this.formCadastro)
          .then((res) => {
            this.passoAtual = 2;
            this.passo = 2;
            this.aguardeCadastro = false;
            this.paginaAtual = 1;
            this.consolidado = res.data.consolidado;
            this.boletosRateio = res.data.list;

            this.qtdPaginas = this.consolidado.boletos / 30;
            if (this.qtdPaginas % 1 != 0) this.qtdPaginas++;
            this.qtdPaginas = parseInt(this.qtdPaginas);

            this.qtdTotal = this.consolidado.boletos;
          })
          .catch((error) => {
            this.aguardeCadastro = false;
            notify.notifyFail(
              this.$vs,
              error || 'Não foi possível buscar Dados',
            );
          })
          .finally(() => {
            this.$vs.loading.close();
          });
      }
    },
    gerarLancamentosFinanceiros() {
      if (this.formCadastro.idEmpresa) {
        this.$vs.loading();
        service
          .post('Rateios', 'gerarLancamentosFinanceiros', this.formCadastro)
          .then((boletosEmProcessamento) => {
            const { processando } = boletosEmProcessamento.data;

            if (!processando) {
              this.aguardeCadastro = false;
              this.$vs.loading.close();
              this.$vs.notify({
                position: 'top-center',
                title: 'Atenção',
                text: 'Lançamentos Gerados com sucesso, disponiveis para remessa ou enviados para o GalaxPay',
                color: 'success',
              });
              this.$emit('concluido');

              return;
            }

            this.aguardeCadastro = false;
            this.passo = 1;
            this.passoAtual = 1;

            this.$vs.loading.close();
            notify.notifyFail(
              this.$vs,
              'Há boletos em processamento com a mesma configuração desse rateio, aguarde a finalização',
            );
          })
          .catch((error) => {
            this.aguardeCadastro = false;
            this.$vs.loading.close();

            notify.notifyFail(this.$vs, 'Não foi possível buscar Dados');
          });
      }
    },
    abreVeiculosParticipantes() {
      if (this.formCadastro.idEmpresa) {
        var objSend = { ...this.formCadastro };
        objSend.showVeiculos = true;
        this.$vs.loading();
        service
          .post('Rateios', 'buscaCotas', objSend)
          .then((res) => {
            this.aguardeCadastro = false;
            this.veiculosParticipantes = res.data;
            this.modalVeiculosParticipantes = true;
            this.$vs.loading.close();
          })
          .catch(() => {
            this.aguardeCadastro = false;
            this.$vs.loading.close();
            this.$vs.notify({
              position: 'top-center',
              title: 'Atenção',
              text: 'Não foi possível buscar Dados',
              color: 'danger',
            });
          });
      }
    },
    buscarCotas() {
      if (this.formCadastro.idEmpresa) {
        this.$vs.loading();
        service
          .post('Rateios', 'buscaCotas', this.formCadastro)
          .then((res) => {
            this.aguardeCadastro = false;

            this.formCadastro.totalCotas =
              res.data[0].totalCotas == null ? 0 : res.data[0].totalCotas;

            this.totalVeiculos = res.data[0].qtdVeiculos;
            this.$vs.loading.close();
          })
          .catch(() => {
            this.aguardeCadastro = false;
            this.$vs.loading.close();
            this.$vs.notify({
              position: 'top-center',
              title: 'Atenção',
              text: 'Não foi possível buscar Dados',
              color: 'danger',
            });
          });
      }
    },
    buscaDadosCadastroEmpresa() {
      if (localStorage.getItem('user-token')) {
        try {
          this.$vs.loading();
          const decoded = jwt.decode(localStorage.getItem('user-token'));
          this.formCadastro.idEmpresa = decoded.id_empresa;
          this.idEmpresa = decoded.id_empresa;

          service
            .getAll(
              'g',
              {},
              'empresas/list/idEmpresa/' + this.formCadastro.idEmpresa,
            )
            .then((res) => {
              const decryptedData = decryptData(res.data);
              this.dadosEmpresa = decryptedData;
              this.ativaMascarasVeiculos =
                this.dadosEmpresa[0].ativaMascarasVeiculos;
              var dias = this.dadosEmpresa[0].diasVencimento.split(',');
              this.diasVencimento.push({ id: 0, label: 'Selecionar Todos' });
              dias.forEach((element) => {
                this.diasVencimento.push({ id: element, label: element });
              });
              //this.carregando = false;

              this.$vs.loading.close();
            })
            .catch((e) => {
              this.$vs.notify({
                position: 'top-center',
                title: 'Atenção',
                text: e,
                color: 'danger',
              });
              this.$vs.loading.close();
            });
        } catch (error) {
          console.error(error);
        }
      }
    },
    onSubmit() {
      let [data, hora] = moment(this.formCadastro.cadastrosAte)
        .format('yyyy-MM-DD HH:mm:ss')
        .split(' ');

      // cadastrados até o fim do dia da data selecionada
      hora = '23:59:59';
      const _cadastrosAte = `${data} ${hora}`;

      const referenciasValidas = this.validarDatasReferencias();
      if (referenciasValidas.length > 0) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: referenciasValidas,
          color: 'danger',
        });
        return;
      }

      this.resultadoCritica = [];
      this.formCadastro.idEmpresa = this.idEmpresa;

      var action = 'Atualizar';
      var msgRetorno = 'Dados Atualizados com sucesso';
      if (!this.formCadastro.idRateio) {
        action = 'Adicionar';
        msgRetorno = `Registro Adicionado com sucesso`;
      }

      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.formCadastro.tipoRateio == 'Detalhado') {
            this.formCadastro.tipoFipe = this.regionais[0].tipoFipe;
          }
          this.$vs.loading();
          this.aguardeCadastro = true;

          const _formCadastro = {
            ...this.formCadastro,
            cadastrosAte: _cadastrosAte,
          };

          service
            .post('Rateios', action, _formCadastro)
            .then((res) => {
              this.formCadastro.idRateio = res.data.idRateio;
              this.criticas = JSON.parse(res.data.critica);
              this.passo = res.data.passo;
              this.passoAtual = this.passo;
              this.aguardeCadastro = false;
              this.$vs.loading.close();
              //this.$emit("concluido");

              this.naoExibirCriticas();

              this.$vs.notify({
                position: 'top-center',
                title: 'Atenção',
                text: msgRetorno,
                color: 'success',
              });
            })
            .catch((error) => {
              this.$vs.loading.close();
              this.aguardeCadastro = false;
              this.$vs.notify({
                position: 'top-center',
                title: 'Atenção',
                text: error,
                color: 'danger',
              });
            });
        }
      });
    },
    onReset(evt) {
      evt.preventDefault();
      this.resetForm();
      this.$nextTick(() => {
        this.show = true;
      });
    },
    validarDatasReferencias() {
      let msgErro = '';
      const competenciaEventos = this.formCadastro.mesRefenciaEventos;
      const competenciaBoleto = this.formCadastro.mesReferenciaBoleto;
      const mesVencimentoBoleto = this.formCadastro.mesVencimentoBoleto;
      const diasVencimento = this.formCadastro.diasVencimento;

      if (diasVencimento.length === 0) {
        msgErro = 'Selecione os dias de vencimento';

        return msgErro;
      }

      const dataAtual = moment();
      //verifica se a data de vencimento é maior que o dia corrente
      // retorna false se algum dia de vencimento for menor que o dia atual
      const diasVencimentoPosteriorDiacorrente = diasVencimento.reduce(
        (acc, dia) => {
          const arrayControleVencimentos = [];
          const ajusteDia = dia - 1;
          const diaVencimento = moment(mesVencimentoBoleto).add(
            ajusteDia,
            'days',
          );
          arrayControleVencimentos.push(diaVencimento.isAfter(dataAtual));
          return (acc = !arrayControleVencimentos.includes(false));
        },
        true,
      );

      // verifica a competencia dos eventos
      const compEventosAnterioVecimento = moment(
        competenciaEventos,
      ).isSameOrBefore(mesVencimentoBoleto)
        ? true
        : false;

      msgErro = compEventosAnterioVecimento
        ? ''
        : 'A competência dos eventos deve ser menor que o mês de vencimento';

      if (msgErro.length > 0) {
        return msgErro;
      }

      //verifica se data de vencimento dos boletos é menor que data de competência
      const compBoletoAnterioVencimento = moment(
        competenciaBoleto,
      ).isSameOrBefore(mesVencimentoBoleto)
        ? true
        : false;

      msgErro = compBoletoAnterioVencimento
        ? ''
        : 'A competência dos boletos deve ser menor que o mês de vencimento';

      if (msgErro.length > 0) {
        return msgErro;
      }

      if (!diasVencimentoPosteriorDiacorrente) {
        msgErro =
          'Não é permitido gerar boletos vencidos, ajuste os dias de vencimento';

        return msgErro;
      }

      return msgErro;
    },
    preencheDatasReferencias() {
      const mesRefenciaEventos = this.formCadastro.mesRefenciaEventos;
      const mesReferenciaBoleto = moment(mesRefenciaEventos);
      const mesVencimentoBoleto = moment(mesReferenciaBoleto).add(1, 'month');

      this.formCadastro.mesReferenciaBoleto = mesReferenciaBoleto.format();
      this.formCadastro.mesVencimentoBoleto = mesVencimentoBoleto.format();
      this.habilitarDatasReferencias = false;
    },
    naoExibirCriticas() {
      const tipoCriticaRemover = ['Veículos com Cota Errada'];

      const bemProtege = functions.verificaEmpresaBemProtege(
        this.formCadastro.idEmpresa,
      );

      const _criticas = this.criticas;

      if (bemProtege) {
        _criticas.forEach((item, index) => {
          const { tipo } = item;
          if (tipoCriticaRemover.includes(tipo)) {
            this.criticas.splice(index, 1);
          }
        });
      }
    },
    buscar(pagina) {
      console.log(this.formFiltro);
      if (this.formCadastro.idEmpresa) {
        this.$vs.loading();
        let objSend = { ...this.formFiltro };
        objSend.pagina = pagina;
        objSend.idEmpresa = this.formCadastro.idEmpresa;
        objSend.idRateio = this.formCadastro.idRateio;
        service
          .post('Rateios', 'buscaFinanceiroResumo', objSend)
          .then((res) => {
            this.boletosRateio = res.data.list;
            if (res.data.qtdTotalFiltro) {
              this.qtdPaginas = res.data.qtdTotalFiltro / 30;
              if (this.qtdPaginas % 1 != 0) this.qtdPaginas++;
              this.qtdPaginas = parseInt(this.qtdPaginas);
              this.qtdTotal = res.data.qtdTotalFiltro;
            }
          })
          .catch(() => {
            this.aguardeCadastro = false;
            notify.notifyFail(this.$vs, 'Não foi possível buscar Dados');
          })
          .finally(() => {
            this.$vs.loading.close();
          });
      }
    },
  },
  created() {
    this.$validator.localize('ptBr', locale);
  },
  async mounted() {
    this.buscaDadosCadastroEmpresa();

    this.buscaDadosSelects(
      'domTipoFipe',
      'tiposFipe',
      'nomeTipo',
      'idTipoFipe',
    );
    this.buscaDadosSelectsPorEmpresa(
      'empresasCarteiraCobranca',
      'carteirasCobranca',
      'nomeCarteira',
      'idCarteira',
    );
    this.buscaDadosAtivosSelectsPorEmpresa(
      'status',
      'situacoes',
      'nomeStatus',
      'idStatus',
    );
    // this.$i18n.locale = functions.setLocaleBasedOnCompany();
    await this.translateProposal();
  },
  components: {
    BotaoSubmit,
    Money,
    Datepicker,
    AlertNoneRateios,
    AlertConsolidado,
    AutoComplete,
  },
};
</script>

<style scoped>
.div-show {
  display: 'block';
}
.div-hide {
  display: none;
}

li.activeChild {
  border-bottom: 1px solid rgba(var(--vs-primary), 1) !important;
}
</style>

<style scoped lang="scss">
.table-bordered {
  display: table;
  border-collapse: separate;
  box-sizing: border-box;
  border-spacing: 2px;
  border-color: grey;
  width: 100%;
  border: 1px solid gray;
  tr td {
    padding: 2px;
  }
  tr:nth-child(2n) {
    background: #efefef !important;
  }
}
.vdp-datepicker input {
  width: 100%;
}
</style>
